module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/air-conditioning-7b55153923f9fbff5d0904d20e10934c.svg";